import { useEffect, useRef, type ReactNode } from 'react';
import { cn } from '../cn.js';

/** Right-hand side panel built on the native <dialog> (focus trap, Esc, backdrop click). */
export function Sheet({
  open,
  onClose,
  label,
  children,
  className,
}: {
  open: boolean;
  onClose: () => void;
  label: string;
  children: ReactNode;
  className?: string;
}) {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = ref.current;
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);

  return (
    <dialog
      ref={ref}
      aria-label={label}
      onClose={onClose}
      onClick={(event) => {
        if (event.target === ref.current) onClose();
      }}
      className={cn(
        'fixed inset-y-0 right-0 left-auto m-0 h-dvh max-h-dvh w-full max-w-xl border-l border-border bg-surface p-0 text-text shadow-float',
        'open:animate-slide-in sm:inset-y-2 sm:right-2 sm:h-[calc(100dvh-1rem)] sm:max-h-[calc(100dvh-1rem)] sm:rounded-2xl sm:border',
        className,
      )}
    >
      {open && children}
    </dialog>
  );
}
